import React from 'react';
// import Helpers from '@/app/_lib/helpers';
import { UserInChat } from '../../../../types/chat';
import { Avatar, Divider } from 'antd';
import { DocumentText1, Gallery } from 'iconsax-react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  setSelectedUser,
  setReceiverId,
  useChat,
  setSelectedRoomId,
  setSelectedAllUsers,
  setIsGrouping,
  setDisputeId,
  setCanCancelFriendlyStage,
  setIsClosed,
} from '../../../../store/slices/chat';
import TitleText from '../../../../components/atoms/TitleText';
import InfoText from '../../../../components/atoms/InfoText';
import Helpers from '../../../../lib/helpers';

interface UserChatItemProps extends UserInChat {
  handleSeenOnClick?: (roomId: string | number) => void;
}

const UserChatItem = ({
  handleSeenOnClick,
  ...userData
}: UserChatItemProps) => {
  const {
    users,
    lastMessage,
    type,
    lastMessageTime,
    unRead,
    id,
    isGrouping,
    roomId,
    disputeId,
    actionsDto,
    isClosed,
  } = userData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const chatRoomId = searchParams.get('chatRoomId');
  const { receiverId, selectedUser, selectedRoomId } = useChat();
  const activeRoomId = chatRoomId || selectedRoomId;

  const formattedTime = Helpers.formatTime(
    //@ts-expect-error
    Helpers.convertUTCToUserLocal(lastMessageTime)
  );

  return (
    <>
      <div
        onClick={() => {
          dispatch(setSelectedUser(userData));
          dispatch(setSelectedAllUsers(users));
          dispatch(setIsGrouping(Boolean(isGrouping)));
          if (!isGrouping) {
            dispatch(setReceiverId(users?.[0]?.id as number));
            // Set roomId and isClosed for non-grouping chats as well
            if (roomId) {
              dispatch(setSelectedRoomId(roomId as string));
            }
            dispatch(setIsClosed(isClosed));
          } else {
            dispatch(setSelectedRoomId(roomId as string));
            dispatch(setDisputeId(disputeId as string));
            dispatch(
              setCanCancelFriendlyStage(
                //@ts-expect-error
                actionsDto?.canCancelFriendlyStage || undefined
              )
            );
            dispatch(setIsClosed(isClosed));
          }
          if (roomId) {
            navigate(`/messages?chatRoomId=${roomId}`, { replace: true });
          }
          handleSeenOnClick?.(roomId);
        }}
        className={cn(
          'userCharItem flex flex-1 items-center gap-2 py-4 cursor-pointer rounded-lg p-2',
          {
            'bg-pink-50 dark:bg-black-500':
              roomId === activeRoomId ||
              (!isGrouping && receiverId?.toString() === users?.[0]?.toString()),
          }
        )}
      >
        <div>
          {isGrouping ? (
            <Avatar.Group
              max={{
                count: 2,
                style: { color: '#f56a00', backgroundColor: '#fde3cf' },
              }}
            >
              {users?.map((item, index) => (
                <>
                  <Avatar
                    src={item?.image}
                    size={58}
                    className={`${index > 0 ? 'z-10' : 'z-20'
                      } !border-light-success !border-2 !overflow-hidden`}
                  />
                </>
              ))}
            </Avatar.Group>
          ) : (
            <Avatar
              src={users?.[0]?.image}
              size={58}
              className={` !border-light-success !border-2 !overflow-hidden`}
              alt="avatar"
            />
          )}
        </div>
        <div className="userChatItem-content flex items-start justify-between flex-1 flex-wrap">
          <div className="flex flex-col ">
            {isGrouping ? (
              <TitleText
                text={Helpers.truncateText(
                  users.map((user) => user.name).join(' & '),
                  20
                )}
                size="base"
                className="text-left"
              />
            ) : (
              <TitleText
                text={users?.[0]?.name}
                size="base"
                className="text-left"
              />
            )}

            <div className="message-image flex gap-1">
              {type === 'IMAGE' && <Gallery size={16} />}
              {type === 'FILE' && <DocumentText1 size={16} />}
              <InfoText
                text={Helpers.truncateText(lastMessage, 20)}
                className={cn(
                  '!text-light-text-primary dark:text-dark-text-primary font-semibold',
                  {
                    '!font-normal !text-text-secondary':
                      !unRead ||
                      (isGrouping
                        ? roomId == selectedRoomId
                        : selectedUser?.id === users?.[0].id),
                  }
                )}
              />
            </div>
          </div>
          <div className="flex items-center  gap-2">
            <div className="chat-time text-text-secondary">{formattedTime}</div>
            {!isGrouping && unRead && selectedUser?.id !== users?.[0].id && (
              <div className="chat-status w-2 h-2 bg-light-alert rounded-[4px]"></div>
            )}
            {isGrouping && roomId !== selectedRoomId && unRead ? (
              <div className="chat-status w-2 h-2 bg-light-alert rounded-[4px]"></div>
            ) : null}
          </div>
        </div>
      </div>
      <Divider className="!m-0" />
    </>
  );
};
export default UserChatItem;
